import { useEffect, useState } from 'react';

/**
 * Returns true while the viewport width is at or below `maxWidth` (default
 * 640px). Components use this to switch their layout to the "mobile" full-
 * width footer style — on touch devices and on a desktop window that has
 * been narrowed past the breakpoint.
 */
export function useNarrowViewport(maxWidth = 640): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [matches, setMatches] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
